import { Tag, TooltipSettings } from 'src/components/tag-tooltip/types';
import * as THREE from 'three';
import { ReactNode } from 'react';

export enum Direction {
  Left = 'left',
  Right = 'right',
  Top = 'top',
  Bottom = 'bottom'
}

export interface IotItem {
  name: string;
  icon: string | null;
  value: number;
  measureUnit?: string;
  externalDeviceId?: string | number;
  relatedMeasureUnit?: { [key: string]: string | number };
  measureName?: string;
}

export interface IotTagTooltipProps {
  items: IotItem[];
}

export interface AnchorProps {
  tag: Tag;
  camera: THREE.Camera;
  renderer: THREE.Renderer;
  settings?: Partial<TooltipSettings>;
  children: ReactNode;
}
